import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import type { Voucher } from '../types/voucher.type';

export const GetVoucherSchema = z.object({
  voucher_id: z.string().min(1, {
    message: 'id voucher tidak boleh kosong!',
  }),
});
export type GetVoucherPayload = z.infer<typeof GetVoucherSchema>;
export type GetVoucherResponse = ApiResponse<Voucher>;

export const getVoucher = async (
  payload: GetVoucherPayload
): Promise<GetVoucherResponse> => {
  const { voucher_id } = payload;
  const url = `voucher/${voucher_id}`;

  return await apiClient.get(url);
};

export const GET_VOUCHER_QUERY_KEY = 'voucher';
export function getVoucherQueryOptions(payload: GetVoucherPayload) {
  return queryOptions({
    queryKey: [GET_VOUCHER_QUERY_KEY, payload.voucher_id],
    queryFn: () => getVoucher(payload),
  });
}
